module.exports = __webpack_public_path__ + "static/images/containers/ChallengeView/components/Leaderboard/images/clan-divider.ed652697.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ChallengeView/components/Leaderboard/images/clan-divider.png
// module id = 2812
// module chunks = 11